import * as FileSaver from "file-saver";
import { salesReportConstants } from "../../constants";
import { hideLoader, showLoader } from "./Loader";
import { showMessage } from "../../helpers";
import {
  getConsolidatedSalesReport,
  getSalesReport,
  getDiagnosticsSalesReport,
  downloadConsolidatedSalesReport,
  postSalesReport,
  postDiagnosticsSalesReport,
  adminGetSalesReport,
  adminGetDiagnosticsSalesReport,
  adminPostSalesReport,
  adminPostDiagnosticsSalesReport,
  approveSalesReport,
  submitSalesReport,
  markSalesReportMessageRead,
  getProductsToBeVerified,
  postProductsToBeVerified,
} from "../../services";

export const getApiSalesData = (onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_API_SALES_REPORT_REQUEST });
    getSalesReport("api", quarter_name)
      .then((response) => {
        dispatch({
          type: salesReportConstants.GET_API_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.GET_API_SALES_REPORT_FAILURE });
        console.log(error);
      });
  };
};

export const getFdfSalesData = (onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_FDF_SALES_REPORT_REQUEST });
    getSalesReport("fdf", quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_FDF_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.GET_FDF_SALES_REPORT_FAILURE });
        console.log(error);
      });
  };
};

export const getDiagnosticsSalesData = (onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_DIAGNOSTICS_SALES_REPORT_REQUEST });
    getDiagnosticsSalesReport(quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_DIAGNOSTICS_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.GET_DIAGNOSTICS_SALES_REPORT_FAILURE });
        console.log(error);
      });
  };
};

export const getAdminConsolidatedApiReport = (data, onSuccess) => {
  return (dispatch) => {
    dispatch({
      type: salesReportConstants.GET_CONSOLIDATED_API_SALES_REPORT_REQUEST,
    });
    getConsolidatedSalesReport("api", data)
      .then((response) => {
        dispatch({
          type: salesReportConstants.GET_CONSOLIDATED_API_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: salesReportConstants.GET_CONSOLIDATED_API_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const getAdminConsolidatedFdfReport = (data, onSuccess) => {
  return (dispatch) => {
    dispatch({
      type: salesReportConstants.GET_CONSOLIDATED_FDF_SALES_REPORT_REQUEST,
    });
    getConsolidatedSalesReport("fdf", data)
      .then((response) => {
        dispatch({
          type: salesReportConstants.GET_CONSOLIDATED_FDF_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: salesReportConstants.GET_CONSOLIDATED_FDF_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const downloadApiSalesReport = (filename, apiRequestObj, onSuccess) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.DOWNLOAD_API_SALES_REPORT_REQUEST });
    downloadConsolidatedSalesReport("api", apiRequestObj)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.DOWNLOAD_API_SALES_REPORT_SUCCESS,
        });
        FileSaver.saveAs(response, filename);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.DOWNLOAD_API_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const downloadFdfSalesReport = (filename, fdfRequestObj, onSuccess) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.DOWNLOAD_FDF_SALES_REPORT_REQUEST });
    downloadConsolidatedSalesReport("fdf", fdfRequestObj)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.DOWNLOAD_FDF_SALES_REPORT_SUCCESS,
        });
        FileSaver.saveAs(response, filename);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.DOWNLOAD_FDF_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const postApiSalesReportData = (data, onSuccess, onError) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.POST_API_SALES_REPORT_REQUEST });
    postSalesReport("api", data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.POST_API_SALES_REPORT_SUCCESS });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.POST_API_SALES_REPORT_FAILURE });
        showMessage("error", error.toString());
        if (onError) {
          onError();
        }
      });
  };
};

export const postFdfSalesReportData = (data, onSuccess, onError) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.POST_FDF_SALES_REPORT_REQUEST });
    postSalesReport("fdf", data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.POST_FDF_SALES_REPORT_SUCCESS });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_FDF_SALES_REPORT_FAILURE,
          data: error ? error : {},
        });
        showMessage("error", error.message.toString());
        if (onError) {
          onError();
        }
      });
  };
};

export const postDiagnosticsSalesReportData = (data, onSuccess, onError) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.POST_DIAGNOSTICS_SALES_REPORT_REQUEST });
    postDiagnosticsSalesReport(data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.POST_DIAGNOSTICS_SALES_REPORT_SUCCESS });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_DIAGNOSTICS_SALES_REPORT_FAILURE,
          data: error ? error : {},
        });
        showMessage("error", error.message.toString());
        if (onError) {
          onError();
        }
      });
  };
};

export const getAdminApiSalesData = (id, onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_ADMIN_API_SALES_REPORT_REQUEST });
    adminGetSalesReport("api", id, quarter_name)
      .then((response) => {
        dispatch({
          type: salesReportConstants.GET_ADMIN_API_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_ADMIN_API_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const getAdminFdfSalesData = (id, onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_ADMIN_FDF_SALES_REPORT_REQUEST });
    adminGetSalesReport("fdf", id, quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_ADMIN_FDF_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_ADMIN_FDF_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const getAdminDiagnosticsSalesData = (id, onSuccess, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.GET_ADMIN_DIAGNOSTICS_SALES_REPORT_REQUEST });
    adminGetDiagnosticsSalesReport(id, quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_ADMIN_DIAGNOSTICS_SALES_REPORT_SUCCESS,
          data: response ? response : {},
        });
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.GET_ADMIN_DIAGNOSTICS_SALES_REPORT_FAILURE,
        });
        console.log(error);
      });
  };
};

export const postAdminApiSalesData = (id, data, onSuccess, onError, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({
      type: salesReportConstants.POST_ADMIN_API_SALES_REPORT_REQUEST,
    });
    adminPostSalesReport("api", id, data, quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_API_SALES_REPORT_SUCCESS,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_API_SALES_REPORT_FAILURE,
        });
        showMessage("error", error.toString());
        if (onError) {
          onError();
        }
      });
  };
};

export const postAdminFdfSalesData = (id, data, onSuccess, onError, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({
      type: salesReportConstants.POST_ADMIN_FDF_SALES_REPORT_REQUEST,
    });
    adminPostSalesReport("fdf", id, data, quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_FDF_SALES_REPORT_SUCCESS,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_FDF_SALES_REPORT_FAILURE,
        });
        if (error.message && error.mapping_id) {
          showMessage(
            "error",
            error.message.toString() + "-" + error.mapping_id.toString(),
          );
        } else {
          showMessage("error", error.toString());
        }
        if (onError) {
          onError();
        }
      });
  };
};

export const postAdminDiagnosticsSalesData = (id, data, onSuccess, onError, quarter_name) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({
      type: salesReportConstants.POST_ADMIN_DIAGNOSTICS_SALES_REPORT_REQUEST,
    });
    adminPostDiagnosticsSalesReport(id, data, quarter_name)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_DIAGNOSTICS_SALES_REPORT_SUCCESS,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_ADMIN_DIAGNOSTICS_SALES_REPORT_FAILURE,
        });
        if (error.message && error.mapping_id) {
          showMessage(
            "error",
            error.message.toString() + "-" + error.mapping_id.toString(),
          );
        } else {
          showMessage("error", error.toString());
        }
        if (onError) {
          onError();
        }
      });
  };
};


export const approveSalesReportData = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.APPROVE_SALES_REPORT_REQUEST });
    approveSalesReport(data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.APPROVE_SALES_REPORT_SUCCESS });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.APPROVE_SALES_REPORT_FAILURE });
        showMessage("error", error.toString());
      });
  };
};

export const submitSalesReportData = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({ type: salesReportConstants.SUBMIT_SALES_REPORT_REQUEST });
    submitSalesReport(data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.SUBMIT_SALES_REPORT_SUCCESS });
        showMessage("success", "Reports submitted successfully!");
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(hideLoader());
        dispatch({ type: salesReportConstants.SUBMIT_SALES_REPORT_FAILURE });
        showMessage("error", error.toString());
      });
  };
};

export const partnerMarkSalesReportMessageRead = (type, onSuccess) => {
  return (dispatch) => {
    dispatch({ type: salesReportConstants.MESSAGE_READ_REQUEST });
    markSalesReportMessageRead(type)
      .then((response) => {
        dispatch({ type: salesReportConstants.MESSAGE_READ_SUCCESS });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch({ type: salesReportConstants.MESSAGE_READ_FAILURE });
        showMessage("error", error.toString());
      });
  };
};

export const getAdminProductsToBeVerified = (id, onSuccess) => {
  return (dispatch) => {
    dispatch({
      type: salesReportConstants.GET_PRODUCT_VERIFICATION_LIST_REQUEST,
    });
    getProductsToBeVerified(id)
      .then((response) => {
        dispatch({
          type: salesReportConstants.GET_PRODUCT_VERIFICATION_LIST_SUCCESS,
          data: response ? response : [],
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: salesReportConstants.GET_PRODUCT_VERIFICATION_LIST_FAILURE,
        });
        console.log(error);
      });
  };
};

export const postAdminProductsToBeVerified = (id, data, onSuccess) => {
  return (dispatch) => {
    dispatch(showLoader());
    dispatch({
      type: salesReportConstants.POST_PRODUCT_VERIFICATION_LIST_REQUEST,
    });
    postProductsToBeVerified(id, data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_PRODUCT_VERIFICATION_LIST_SUCCESS,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        dispatch({
          type: salesReportConstants.POST_PRODUCT_VERIFICATION_LIST_FAILURE,
        });
        showMessage("error", error.toString());
      });
  };
};
